<template>
  <BasicLayout :left='left' :middle='middle' :right='right'>
    <template v-slot:left_view>
      <AllNeTree :trackType='1' neType='[mc_cms]'></AllNeTree>
    </template>
    <template v-slot:right_view>
      <checkParamMenu></checkParamMenu>
    </template>
  </BasicLayout>
</template>
<script>
import BasicLayout from '../../layouts/BasicLayout';
import AllNeTree from '../../components/system/ConfigInEx/AllNeTree';
import checkParamMenu from '../../components/system/ConfigInEx/CheckParamMenu';

export default {
  name: 'SignalTrackPage',
  components: {
    BasicLayout,
    AllNeTree,
    checkParamMenu
  },
  data() {
    return {
      left: {
        show: false,
        name: this.$t('Track.resourcesList')
      },
      middle: {
        show: false,
        name: ''
      },
      right: {
        show: true,
        crumb: `${this.$t('MML.cfgManagement')}/${this.$t('NSMF.checkParam')}`
      }
    };
  }
};
</script>
